import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { ProcessActivityObject } from 'src/app/models/orders/order-details-process/process-details/process-activity-object.model';

@Component({
  selector: 'app-process-activity',
  templateUrl: './process-activity.component.html',
  styleUrls: ['./process-activity.component.css']
})
export class ProcessActivityComponent implements OnInit {

  private _processActivity: ProcessActivityObject;
  @Input()
  get processActivity(): any {
    return this._processActivity;
  }
  set processActivity(value: any) {
    this._processActivity = value;
    this.ngOnInit();
  }

  generalTooltip: string;
  stateTooltip: string;
  stateTooltip2: string;
  numberOfErrorsTooltip: string;
  stateIcon: string;
  errorDate: Date;
  type: string;

  constructor() { }

  ngOnInit() {

    this.generalTooltip = this.getGeneralTooltip();
    this.stateTooltip = this.getStateTooltip();
    this.stateIcon = this.getStateIcon();
    this.numberOfErrorsTooltip = this.getNumberOfErrorsTooltip();
  }

  public getGeneralTooltip(): string {
    this.type = this.processActivity.getType() + '\n';
    const information = this.processActivity.getInformation();
    return this.type + information;
  }

  public getStateTooltip(): string {
    const state = 'Estado: ' + this.processActivity.getStatus() + '\n';
    const errors = 'Nº errores acumulados: ' + this.processActivity.getNumberOfErrors();
    if (this.processActivity.getStatus() === 'ERROR' && this.processActivity.getErrorListSize() > 0) {
      this.errorDate = this.processActivity.getErrorList()[0].getErrorDate();
      this.stateTooltip2 = '\n' + errors;
      return this.type + state + 'Fecha del error: ';
    } else { return this.type + state + errors; }
  }

  public getStateIcon(): string {
    switch (this.processActivity.getStatus()) {
      case 'START':
        return 'access_time';
      case 'END':
        return 'done';
      case 'ERROR':
        return 'warning';
      default:
        return 'help';
    }
  }

  public getNumberOfErrorsTooltip(): string {
    return 'Número de errores en la actividad';
  }

}
